



import { Component, Vue } from 'vue-property-decorator';
import { RocketChatModuleMapper } from '@/store/modules/rocketChatSdk';

import Icon from '@/components/common/icon.vue';

const format = (pattern: string, ...args: any[]): string => {
  pattern = pattern.replace(/'{2}/g, '\'');
  // eslint-disable-next-line no-void,valid-typeof
  return pattern.replace(/{(\d+)}/g, (match, i) => ((typeof args[i] === void 0) ? match : args[i]));
};

const Mappers = Vue.extend({
  computed: {
    ...RocketChatModuleMapper.mapGetters(['setup']),
  },
});

@Component({
  components: {
    Icon,
  },
})
export default class RocketChatComponent extends Mappers {
  get chatUrl(): string {
    // В соответствии с требованиями, в каких-то случаях рокет-чат может быть не на отдельном домене, а приконнекчен к основному домену, как папка
    return Array.isArray(this.setup.widgetUrl.match(/\{0\}/g)) ? format(this.setup.widgetUrl, window.location.origin) : this.setup.widgetUrl;
  }

  mounted() {
    const s = document.createElement('script');
    s.innerHTML = `(function(w, d, s, u) {
                w.RocketChat = function(c) { w.RocketChat._.push(c) }; w.RocketChat._ = []; w.RocketChat.url = u;
                var h = d.getElementsByTagName(s)[0], j = d.createElement(s);
                j.async = true; j.src = '${this.chatUrl}/${this.setup.scriptName}?_=${this.setup.scriptVersion}';
                h.parentNode.insertBefore(j, h);
            })(window, document, 'script', '${this.chatUrl}');`;

    document.getElementsByTagName('head')[0].appendChild(s);
  }
}
